<style scoped>
    .main{
        padding: .24rem;
        padding-top: .98rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        min-height: 100vh;
        background: #fff;

    }
    .title{
        font-size: .36rem;
        font-weight: bold;
        color: #000;
        margin: .32rem 0 .2rem;
    }
    .time{
        font-size: .26rem;
        color: #737373;
        margin-bottom: .34rem;
    }
    .content{
        font-size: .3rem;
        color: #000;
        white-space: pre-wrap;
        line-height: .42rem;
    }
</style>
<template>
    <div class="main">
        <topbar text="活动详情"></topbar>
        <div class="title">{{activeDetail.activeTheme}}</div>
        <div class="time">发布时间：{{activeDetail.activeTime}}</div>
        <div class="content" v-html="activeDetail.content"></div>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                pageIndex: 1,
                pageSize: 10,
                noMoreData: false,
                isLoading: false,
                emptyStatus: false,
                companyId:localStorage.getItem('companyId')?localStorage.getItem('companyId'):'',
                activeDetail:''
            }
        },
        components: {
            noMoreData,
            topbar,
            Swiper,
            Slide,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {
            async getActiveDetail() {
                let obj = {}
                obj.activeId = this.$route.query.activeId?this.$route.query.activeId:'';
                let data = await getSources("/bear-scale/api/scaleActive/getActiveDetail.json", obj);
                if (data.status === 0) {
                    this.activeDetail=data.activeDetail
                }else{
                    alert(data.msg)
                }
            },
        },
        destroyed(){
        },
        mounted() {
            this.getActiveDetail();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/activityDetail.vue?760b0b8a